/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AttachPayload,
  CommentDto,
  FindAllByFlowTypeAndFlowIdParams,
  FindUsersDraftByTypeAndFlowIdParams,
  PostRequestPayload,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class CommentsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags comments-controller
   * @name Attach
   * @request POST:/api/v1/comments/{commentId}/attach
   */
  attach = (commentId: string, data: AttachPayload, params: RequestParams = {}) =>
    this.http.request<CommentDto, any>({
      path: `/v1/comments/${commentId}/attach`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static attachPath = '/v1/comments/${commentId}/attach'
  static attachMethod = 'POST'
  /**
   * No description
   *
   * @tags comments-controller
   * @name PostRequest
   * @request POST:/api/v1/comments/request
   */
  postRequest = (data: PostRequestPayload, params: RequestParams = {}) =>
    this.http.request<CommentDto, any>({
      path: `/v1/comments/request`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static postRequestPath = '/v1/comments/request'
  static postRequestMethod = 'POST'
  /**
   * No description
   *
   * @tags comments-controller
   * @name FindAllByFlowTypeAndFlowId
   * @request GET:/api/v1/comments/list
   */
  findAllByFlowTypeAndFlowId = (
    query: FindAllByFlowTypeAndFlowIdParams,
    params: RequestParams = {},
  ) =>
    this.http.request<CommentDto[], any>({
      path: `/v1/comments/list`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findAllByFlowTypeAndFlowIdPath = '/v1/comments/list'
  static findAllByFlowTypeAndFlowIdMethod = 'GET'
  /**
   * No description
   *
   * @tags comments-controller
   * @name FindUsersDraftByTypeAndFlowId
   * @request GET:/api/v1/comments/draft
   */
  findUsersDraftByTypeAndFlowId = (
    query: FindUsersDraftByTypeAndFlowIdParams,
    params: RequestParams = {},
  ) =>
    this.http.request<CommentDto[], any>({
      path: `/v1/comments/draft`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findUsersDraftByTypeAndFlowIdPath = '/v1/comments/draft'
  static findUsersDraftByTypeAndFlowIdMethod = 'GET'
  /**
   * No description
   *
   * @tags comments-controller
   * @name DeleteAttachment1
   * @request DELETE:/api/v1/comments/{commentId}/attach/{attachmentId}
   */
  deleteAttachment = (commentId: string, attachmentId: string, params: RequestParams = {}) =>
    this.http.request<CommentDto, any>({
      path: `/v1/comments/${commentId}/attach/${attachmentId}`,
      method: 'DELETE',
      format: 'json',
      ...params,
    })

  static deleteAttachmentPath = '/v1/comments/${commentId}/attach/${attachmentId}'
  static deleteAttachmentMethod = 'DELETE'
}
